



















































































































































































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';
import ArrowDown from 'vue-material-design-icons/ChevronDown.vue';
import SubjectCard from '@/components/cards/SubjectCard.vue';
import SubjectCarousel from '@/components/SubjectCarousel.vue';
import SearchBar from '@/components/SearchBar.vue';
import pxButton from '@/dex-shared/components/px-button.vue';
import SubjectModel from '@/models/SubjectModel';

export default Vue.extend({
  components: {
    SubjectCard,
    SubjectCarousel,
    SearchBar,
    pxButton,
    ArrowDown,
  },
  data() {
    return {
      selectedExamModeId: null,
      maxSubjects: 12,
      page: 1,
      items: 60,
      isSearching: false,
      searchTerm: '',
    };
  },
  computed: {
    ...mapGetters({
      subjects: 'subjects',
      subjectSearchResult: 'subjectSearchResult',
      highlightedSubjects: 'highlightedSubjects',
      examApplications: 'examApplications',
      examModes: 'examModes',
    }),
    filteredSubjects: function(): SubjectModel[] {
      const subjects = this.isSearching
        ? this.subjectSearchResult
        : this.subjects;

      return !this.selectedExamModeId
        ? subjects
        : subjects.filter(
            (subject: SubjectModel) =>
              subject.examMode().id == this.selectedExamModeId,
          );
    },
  },
  created() {
    this.$store.dispatch('PULL_SUBJECTS', {
      page: this.page,
      items: this.items,
    });
  },
  methods: {
    showMoreSubjects() {
      let subjectsToPull = 8;
      if (this.maxSubjects + subjectsToPull > this.filteredSubjects.length) {
        this.page++;
        if (this.selectedExamModeId) {
          this.$store.dispatch('PULL_SUBJECTS_BY_MODE', {
            examModeId: this.selectedExamModeId,
            page: this.page,
            items: this.items,
          });
        } else {
          this.$store.dispatch('PULL_SUBJECTS', {
            page: this.page,
            items: this.items,
          });
        }
      }
      this.maxSubjects += subjectsToPull;
    },
  },
});
